import { WHATSAPP_URL } from "@/lib/brand";
import { MessageCircle } from "lucide-react";

const WhatsAppFloat = () => (
  <a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noreferrer"
    data-testid="whatsapp-float"
    aria-label="Escríbenos por WhatsApp"
    className="fixed z-40 bottom-6 right-6 flex items-center gap-2 rounded-full pl-3 pr-5 py-3 shadow-lg transition-transform hover:-translate-y-0.5"
    style={{
      background: "#25D366",
      color: "#ffffff",
      boxShadow: "0 14px 30px -12px rgba(37,211,102,0.6)",
    }}
  >
    <span
      className="w-8 h-8 rounded-full flex items-center justify-center"
      style={{ background: "rgba(255,255,255,0.18)" }}
    >
      <MessageCircle size={18} strokeWidth={1.8} />
    </span>
    <span
      className="hidden sm:inline text-[13px]"
      style={{ fontFamily: "Cormorant Garamond, serif", letterSpacing: "0.02em", fontWeight: 600 }}
    >
      Escríbenos por WhatsApp
    </span>
  </a>
);

export default WhatsAppFloat;
